import { IPortabilityCMS } from '@vfit/consumer/data-access';
import { IChooseOperator } from './portability.model';

export const organizePortabilityCard = (portabilityCms: IPortabilityCMS) => {
  const dataToReturn: IChooseOperator = {
    chooseOperator: [
      {
        title: portabilityCms?.portability?.provider?.providerTitles?.providerOne || '',
        textInput: portabilityCms?.portability?.selectInput?.migrationCode || '',
        dropDown: portabilityCms?.portability?.provider?.title || '',
      },
      {
        title: portabilityCms?.portability?.provider?.providerTitles?.providerTwo || '',
        textInput: portabilityCms?.portability?.selectInput?.migrationCode || '',
        dropDown: portabilityCms?.portability?.provider?.title || '',
      },
    ],
    lineInfo: {
      option1: portabilityCms?.portability?.lineInfo?.choice.option1 || '',
      option2: portabilityCms?.portability?.lineInfo?.choice.option2,
    },
  };

  return dataToReturn;
};
